import React, { useEffect, useState } from "react";
import styles from "./SectionList.module.css";
import { isNonEmptyArray } from "../../../../../../common/utils";
import { CustomIconButton, CustomTooltip, icon } from "../../../../../../common/components";
import { CriteriaRow } from "./CriteriaRow";
import { translate } from "../../../../../../common/providers";

export const SectionRow = ({
	detectedValues,
	isAllMode = false,
	launchInProgress = null,
	maxWidth,
	section,
	selectedSection,
	selectedCriteria,
	onSelectCriteria,
	onSelect,
}) => {
	const [subsections, setSubsections] = useState([]);
	useEffect(() => {
		setSubsections(
			(isNonEmptyArray(section?.subsection) && section.subsection.map((sub) => ({ ...sub, open: true }))) || []
		);
	}, [section]);
	const handleOpen = (uuid) => {
		setSubsections((prev) => prev.map((sub) => (sub.uuid === uuid && { ...sub, open: !sub.open }) || sub));
	};
	const emptyResultRow = () =>
		!launchInProgress && (
			<div className={styles["row__empty-state"]}>
				{translate("dashboards.project-sheet.empty-state.section")}
			</div>
		);
	const rowRenderer = (information, isParent, hasChildren) => (
		<div key={information?.uuid || information?.id} className={styles.subsection}>
			<div
				className={`${
					(!launchInProgress && styles.subsection__content) || styles["subsection__content--launched"]
				}`}
				data-has-children={hasChildren}
				data-is-child={!isParent}
				data-open={information.open}
				data-selected={information.uuid === selectedSection}
				role="presentation"
				onClick={() => {
					if (hasChildren && !launchInProgress) {
						handleOpen(information.uuid);
					}
				}}
			>
				<div
					className={styles.content}
					data-has-children={hasChildren}
					role="presentation"
					onClick={() => {
						if (!launchInProgress && typeof onSelect === "function") {
							onSelect(information.uuid);
						}
					}}
				>
					{!launchInProgress && (
						<>
							{hasChildren && (
								<CustomIconButton
									btnClassName={styles.button__btn}
									icon={(information?.open && icon.faChevronDown) || icon.faChevronRight}
									iconClassName={styles.button__icon}
									iconColor="var(--color-black)"
									size="xs"
								/>
							)}
							<CustomTooltip
								showWhenOverflow
								enterDelay={500}
								enterNextDelay={500}
								title={information.name}
							>
								<span className={styles.label}>{information.name}</span>
							</CustomTooltip>
						</>
					)}
				</div>
			</div>
			{information.open && (
				<div className={styles.criteriaContainer} data-is-detections-launched={launchInProgress}>
					{(isNonEmptyArray(information?.layout) &&
						information.layout.map((criteria) => (
							<CriteriaRow
								key={criteria?.uuid || criteria?.id}
								criteria={criteria}
								detectedValues={detectedValues?.find(
									(value) => value.fieldUuid === (criteria?.uuid || criteria?.id)
								)}
								launchInProgress={launchInProgress}
								maxWidth={maxWidth}
								selectedCriteria={selectedCriteria}
								onSelectCriteria={onSelectCriteria}
							/>
						))) ||
						(!launchInProgress && (
							<div className={styles["row__empty-state"]}>
								{translate("dashboards.project-sheet.empty-state.section")}
							</div>
						))}
				</div>
			)}
		</div>
	);
	return (
		<>
			{!isAllMode && (
				<div key={section.uuid} className={styles.section} data-is-detection-launched={!!launchInProgress}>
					{!launchInProgress && section.name}
				</div>
			)}
			<div className={styles.sectionLayout}>
				{isNonEmptyArray(section?.layout) &&
					section.layout.map((criteria) => (
						<CriteriaRow
							key={criteria.uuid}
							criteria={criteria}
							detectedValues={detectedValues?.find(
								(value) => value?.fieldUuid === (criteria?.uuid || criteria?.id)
							)}
							launchInProgress={launchInProgress}
							maxWidth={maxWidth}
							selectedCriteria={selectedCriteria}
							onSelectCriteria={onSelectCriteria}
						/>
					))}
			</div>
			{subsections.map((sub) => rowRenderer(sub, true, isNonEmptyArray(sub?.layout)))}
			{!isNonEmptyArray(section?.layout) && !isNonEmptyArray(subsections) && emptyResultRow()}
		</>
	);
};
